module.exports = __webpack_public_path__ + "f4b6c3cc645ae3079893ac815ee1ccea.png";